import { render, staticRenderFns } from "./UploadImageDialog.vue?vue&type=template&id=45672904&"
import script from "./UploadImageDialog.vue?vue&type=script&lang=js&"
export * from "./UploadImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports